import { Tag } from 'lucide-react';
import React from 'react';
import styles from './SegmentVisualBuilder.module.css';

interface AddDescriptionButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const AddDescriptionButton: React.FC<AddDescriptionButtonProps> = ({
  onClick,
  disabled = false,
}) => (
  <button
    type="button"
    className={styles.addDescriptionBtn}
    onClick={onClick}
    disabled={disabled}
    aria-label="Add description"
    title="Add description">
    <Tag size={14} />
  </button>
);
